var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5H(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2127_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2127_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 25C37 21 42 17 47 17C52 17 57 21 57 27C57 37 37 53 37 57C37 53 17 37 17 27C17 21 22 17 27 17C32 17 37 21 37 25Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2127_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 136H103.765L102.118 160C102.118 160 102.588 154.087 112 154.087C116.706 154.087 124 162.435 124 176.348C124 190.261 120.471 200 111.059 200C101.647 200 100 187.826 100 187.826",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2127_157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187 311C187 315 182 319 177 319C172 319 167 315 167 309C167 299 187 283 187 279C187 283 207 299 207 309C207 315 202 319 197 319C192 319 187 315 187 311Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2127_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2127_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2127_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 129 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2127_157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 -1 207 319)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5H);
export default __webpack_public_path__ + "static/media/5H.9621dfca493cddeec1980b8092d74e41.svg";
export { ForwardRef as ReactComponent };